module.exports = __webpack_public_path__ + "img/icwithdraw.cc3041f9.png";